'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AvailabilityIterator = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MergingStatusIterator = require('./MergingStatusIterator');

var _TimeWindowsIterator = require('./TimeWindowsIterator');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AvailabilityIterator = exports.AvailabilityIterator = function () {
    /**
     * @param availability   availability.Availability
     * @param cal            Moment with tz
     */
    function AvailabilityIterator(_ref) {
        var _ref$availability = _ref.availability,
            availability = _ref$availability === undefined ? {} : _ref$availability,
            cal = _ref.cal;

        _classCallCheck(this, AvailabilityIterator);

        availability = availability || {}; // null availability is treated as empty availability

        this._it = new _MergingStatusIterator.MergingStatusIterator({
            it: new _TimeWindowsIterator.TimeWindowsIterator({
                availability: availability,
                cal: cal
            })
        });
    }

    /** @return Boolean */


    _createClass(AvailabilityIterator, [{
        key: 'hasNext',
        value: function hasNext() {
            return this._it.hasNext();
        }

        /** @return Status */

    }, {
        key: 'next',
        value: function next() {
            return this._it.next();
        }
    }]);

    return AvailabilityIterator;
}();


//////////////////
// WEBPACK FOOTER
// ../node_modules/availability/dist/iterators/AvailabilityIterator.js
// module id = 250
// module chunks = 0